import React from 'react'
import PropTypes from 'prop-types'

import DestinationNotification from './DestinationNotification'
import MessageNotification from './MessageNotification'
import Icon from '@scoir/components-core/dist/components/Icon'

import closeIcon from 'icons/close.svg'

import './InboxItem.scss'

const InboxItem = ({ item, destinations, onDismiss, onMarkAsRead, htmlNotificationComponent }) => {
  const unreadClassName = item.Status !== 'read' ? 'unread' : ''
  const HtmlNotification = htmlNotificationComponent
  return (
    <div className={`inbox-notification ${unreadClassName}`}>
      <span
        onClick={(e) => {
          e.stopPropagation()
          onDismiss()
        }}
      >
        <Icon
          className="close-icon"
          def={closeIcon}
          size="xs"
        />
      </span>
      {item.TypeName === 'Destination' && (
        <DestinationNotification
          item={item}
          destinations={destinations}
          onMarkAsRead={onMarkAsRead}
        />
      )}
      {item.TypeName === 'HTML' && (
        <HtmlNotification
          item={item}
          onClick={onMarkAsRead}
        />
      )}
      {item.TypeName === 'Text' && (
        <MessageNotification
          item={item}
          onClick={onMarkAsRead}
        />
      )}
    </div>
  )
}

InboxItem.defaultProps = {
  htmlNotificationComponent: MessageNotification,
}

InboxItem.propTypes = {
  item: PropTypes.object.isRequired,
  destinations: PropTypes.object,
  onDismiss: PropTypes.func.isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
  onViewHtmlMessage: PropTypes.func,
  htmlNotificationComponent: PropTypes.func,
}

export default InboxItem
